import { render, staticRenderFns } from "./BlogSearch.vue?vue&type=template&id=96887efa"
import script from "./BlogSearch.vue?vue&type=script&lang=js"
export * from "./BlogSearch.vue?vue&type=script&lang=js"
import style0 from "./BlogSearch.vue?vue&type=style&index=0&id=96887efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports